import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './flowambassador3.css'

const Flowambassador3 = (props) => {
  const [isVisible, setIsVisible] = useState(1)
  return (
    <div
      className={`flowambassador3-thq-ambassadors-elm ${props.rootClassName} `}
    >
      {isVisible === 1 && (
        <div className="flowambassador3-thq-banner-elm">
          <span className="flowambassador3-text10 index_black">
            {props.text12}
          </span>
          <h1 className="flowambassador3-text11 heading">{props.heading}</h1>
          <span className="flowambassador3-text12 paragraph">
            {props.text17}
          </span>
          <div className="flowambassador3-container10">
            <button
              onClick={() => setIsVisible(2)}
              className="flowambassador3-button button"
            >
              <span className="flowambassador3-text13">{props.text25}</span>
              <span className="flowambassador3-text14">-&gt;</span>
            </button>
          </div>
          <img
            alt={props.imagealt}
            src={props.imagesrc}
            className="flowambassador3-image10"
          />
          <img
            alt={props.imagealt1}
            src={props.imagesrc1}
            className="flowambassador3-image11"
          />
        </div>
      )}
      {isVisible === 2 && (
        <div className="flow_card">
          <div className="flowambassador3-thq-buttons-elm10">
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador3-container11">
            <div className="flowambassador3-thq-header-elm1">
              <div className="flowambassador3-container12">
                <div className="flowambassador3-container13">
                  <span className="index_black">{props.section4}</span>
                  <div className="flowambassador3-container14">
                    <span className="index_blue">{props.text11}</span>
                    <div className="flowambassador3-thq-divider-elm1"></div>
                    <span className="index_black">{props.text21}</span>
                  </div>
                </div>
                <label className="flowambassador3-thq-name-elm1 heading">
                  {props.name1}
                </label>
              </div>
              <p className="flowambassador3-thq-caption-elm1 paragraph">
                {props.caption21}
              </p>
            </div>
            <div className="flowambassador3-thq-buttons-elm11">
              <div
                onClick={() => setIsVisible(3)}
                className="flowambassador3-thq-button-elm11 flow_button"
              >
                <span className="flowambassador3-thq-text-elm10">
                  {props.text2}
                </span>
              </div>
              <div
                onClick={() => setIsVisible(8)}
                className="flowambassador3-thq-button-elm12 flow_button"
              >
                <span className="flowambassador3-thq-text-elm11">
                  {props.text110}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 3 && (
        <div className="flow_card">
          <div className="flowambassador3-thq-buttons-elm12">
            <div onClick={() => setIsVisible(2)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador3-container15">
            <div className="flowambassador3-thq-header-elm2">
              <div className="flowambassador3-container16">
                <span className="index_black">{props.section11}</span>
                <div className="flowambassador3-container17">
                  <span className="index_blue">{props.text4}</span>
                  <div className="flowambassador3-thq-divider-elm2"></div>
                  <span className="index_black">{props.text5}</span>
                </div>
              </div>
              <label className="flowambassador3-thq-name-elm2 heading">
                {props.name11}
              </label>
            </div>
            <div className="flowambassador3-container18">
              <div className="flowambassador3-container19">
                <div>
                  <div className="flowambassador3-container20">
                    <img
                      alt={props.imageAlt11}
                      src={props.imageSrc11}
                      className="flowambassador3-image12"
                    />
                    <span className="flow_text">{props.text31}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador3-container21">
                    <img
                      alt={props.imageAlt21}
                      src={props.imageSrc21}
                      className="flowambassador3-image13"
                    />
                    <span className="flow_text">{props.text41}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador3-container22">
                    <img
                      alt={props.imageAlt31}
                      src={props.imageSrc3}
                      className="flowambassador3-image14"
                    />
                    <span className="flow_text">{props.text51}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador3-container23">
                    <img
                      alt={props.imageAlt41}
                      src={props.imageSrc41}
                      className="flowambassador3-image15"
                    />
                    <div className="flowambassador3-container24">
                      <span className="flow_text">{props.text61}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flowambassador3-container25">
                    <img
                      alt={props.imageAlt51}
                      src={props.imageSrc51}
                      className="flowambassador3-image16"
                    />
                    <div className="flowambassador3-container26">
                      <span className="flow_text">{props.text71}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador3-thq-buttons-elm13">
              <p className="flowambassador3-thq-caption-elm2 paragraph">
                <span>{props.text27}</span>
                <a href="#ambassador" className="flowambassador3-link1">
                  {props.text28}
                </a>
              </p>
              <div
                onClick={() => setIsVisible(4)}
                className="flowambassador3-thq-button-elm15 flow_button"
              >
                <span className="flowambassador3-thq-text-elm17">
                  {props.text26}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 4 && (
        <div className="flow_card">
          <div className="flowambassador3-thq-buttons-elm14">
            <div onClick={() => setIsVisible(3)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador3-container27">
            <div className="flowambassador3-thq-header-elm3">
              <div className="flowambassador3-container28">
                <div className="flowambassador3-container29">
                  <span className="index_black">{props.section21}</span>
                  <div className="flowambassador3-container30">
                    <span className="index_blue">{props.text13}</span>
                    <div className="flowambassador3-thq-divider-elm3"></div>
                    <span className="index_black">{props.text14}</span>
                  </div>
                </div>
                <label className="flowambassador3-thq-name-elm3 heading">
                  {props.name21}
                </label>
              </div>
            </div>
            <div className="flowambassador3-container31">
              <p className="flowambassador3-thq-caption-elm3 paragraph">
                <span>{props.text8}</span>
                <a href="#brand" className="flowambassador3-link2">
                  {props.text9}
                </a>
              </p>
              <p className="flowambassador3-thq-caption-elm4 paragraph">
                {props.caption21111}
              </p>
            </div>
            <div className="flowambassador3-thq-field-elm15">
              <div className="flowambassador3-container32">
                <img
                  alt={props.imageAlt61}
                  src={props.imageSrc61}
                  className="flowambassador3-image17 flow_image"
                />
                <span className="flow_text2">
                  <span>{props.text37}</span>
                  <span className="flowambassador3-text24">{props.text38}</span>
                  <span className="flowambassador3-text25">{props.text39}</span>
                </span>
              </div>
            </div>
            <div className="flowambassador3-thq-buttons-elm15">
              <p className="flowambassador3-thq-caption-elm5 paragraph">
                <span>{props.text10}</span>
                <a href="#strategy" className="flowambassador3-link3">
                  {props.text29}
                </a>
              </p>
              <div
                onClick={() => setIsVisible(5)}
                className="flowambassador3-thq-button-elm18 flow_button"
              >
                <span className="flowambassador3-thq-text-elm19">
                  {props.text81}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 5 && (
        <div className="flow_card">
          <div className="flowambassador3-thq-buttons-elm16">
            <div onClick={() => setIsVisible(4)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador3-container33">
            <div className="flowambassador3-thq-header-elm4">
              <div className="flowambassador3-container34">
                <span className="index_black">{props.section31}</span>
                <div className="flowambassador3-container35">
                  <span className="index_blue">{props.text15}</span>
                  <div className="flowambassador3-thq-divider-elm4"></div>
                  <span className="index_black">{props.text16}</span>
                </div>
              </div>
              <label className="flowambassador3-thq-name-elm4 heading">
                {props.name31}
              </label>
            </div>
            <div className="flowambassador3-thq-field-elm16">
              <div className="flowambassador3-container36">
                <img
                  alt={props.imageAlt71}
                  src={props.imageSrc71}
                  className="flowambassador3-image18 flow_image"
                />
                <div className="flowambassador3-container37">
                  <span className="flow_text2">{props.text101}</span>
                  <div className="flowambassador3-container38">
                    <img
                      alt={props.imageAlt81}
                      src={props.imageSrc81}
                      className="flowambassador3-image19"
                    />
                    <span className="flow_text">{props.text111}</span>
                  </div>
                  <div className="flowambassador3-container39">
                    <img
                      alt={props.imageAlt92}
                      src={props.imageSrc91}
                      className="flowambassador3-image20"
                    />
                    <span className="flow_text">{props.text121}</span>
                  </div>
                  <div className="flowambassador3-container40">
                    <img
                      alt={props.imageAlt912}
                      src={props.imageSrc911}
                      className="flowambassador3-image21"
                    />
                    <span className="flow_text">{props.text1212}</span>
                  </div>
                  <div className="flowambassador3-container41">
                    <img
                      alt={props.imageAlt9111}
                      src={props.imageSrc9111}
                      className="flowambassador3-image22"
                    />
                    <span className="flow_text">{props.text12111}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador3-thq-buttons-elm17">
              <div
                onClick={() => setIsVisible(6)}
                className="flowambassador3-thq-button-elm21 flow_button"
              >
                <span className="flowambassador3-thq-text-elm25">
                  {props.text91}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 6 && (
        <div className="flow_card">
          <div className="flowambassador3-thq-buttons-elm18">
            <div onClick={() => setIsVisible(5)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador3-container42">
            <div className="flowambassador3-thq-header-elm5">
              <div className="flowambassador3-container43">
                <span className="index_black">{props.section51}</span>
                <div className="flowambassador3-container44">
                  <span className="index_blue">{props.text19}</span>
                  <div className="flowambassador3-thq-divider-elm5"></div>
                  <span className="index_black">{props.text20}</span>
                </div>
              </div>
              <label className="flowambassador3-thq-name-elm5 heading">
                {props.name51}
              </label>
            </div>
            <div className="flowambassador3-thq-field-elm17">
              <div className="flowambassador3-container45">
                <img
                  alt={props.imageAlt131}
                  src={props.imageSrc131}
                  className="flowambassador3-image23 flow_image"
                />
                <div className="flowambassador3-container46">
                  <span className="flow_text2">{props.text181}</span>
                  <div className="flowambassador3-container47">
                    <img
                      alt={props.imageAlt141}
                      src={props.imageSrc141}
                      className="flowambassador3-image24"
                    />
                    <span className="flow_text">{props.text191}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador3-thq-buttons-elm19">
              <div
                onClick={() => setIsVisible(7)}
                className="flowambassador3-thq-button-elm24 flow_button"
              >
                <span className="flowambassador3-thq-text-elm28">
                  {props.text171}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 7 && (
        <div className="flow_card">
          <div className="flowambassador3-thq-buttons-elm20">
            <div onClick={() => setIsVisible(6)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador3-container48">
            <div className="flowambassador3-thq-header-elm6">
              <div className="flowambassador3-container49">
                <span className="index_black">{props.section61}</span>
                <div className="flowambassador3-container50">
                  <span className="index_blue">{props.text211}</span>
                  <div className="flowambassador3-thq-divider-elm6"></div>
                  <span className="index_black">{props.text22}</span>
                </div>
              </div>
              <label className="flowambassador3-thq-name-elm6 heading">
                {props.name61}
              </label>
            </div>
            <div className="flowambassador3-thq-field-elm18">
              <div className="flowambassador3-container51">
                <img
                  alt={props.imageAlt151}
                  src={props.imageSrc151}
                  className="flowambassador3-image25 flow_image"
                />
                <div className="flowambassador3-container52">
                  <span className="flow_text2">{props.text212}</span>
                  <div className="flowambassador3-container53">
                    <img
                      alt={props.imageAlt161}
                      src={props.imageSrc161}
                      className="flowambassador3-image26"
                    />
                    <span className="flow_text">{props.text221}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador3-thq-buttons-elm21">
              <div
                onClick={() => setIsVisible(8)}
                className="flowambassador3-thq-button-elm27 flow_button"
              >
                <span className="flowambassador3-thq-text-elm31">
                  {props.text201}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 8 && (
        <div className="flow_card">
          <div className="flowambassador3-thq-buttons-elm22">
            <div onClick={() => setIsVisible(7)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador3-container54">
            <div className="flowambassador3-thq-header-elm7">
              <div className="flowambassador3-container55">
                <span className="index_black">{props.section71}</span>
                <div className="flowambassador3-container56">
                  <span className="index_blue">{props.text23}</span>
                  <div className="flowambassador3-thq-divider-elm7"></div>
                  <span className="index_black">{props.text24}</span>
                </div>
              </div>
              <label className="flowambassador3-thq-name-elm7 heading">
                {props.name71}
              </label>
            </div>
            <div className="flowambassador3-container57">
              <a
                href="https://www.instagram.com/romania/"
                target="_blank"
                rel="noreferrer noopener"
                className="flowambassador3-link4"
              >
                <div className="flowambassador3-thq-field-elm19 ambassador_contact">
                  <div className="flowambassador3-container58">
                    <img
                      alt={props.imageAlt1031}
                      src={props.imageSrc1131}
                      className="flowambassador3-image27"
                    />
                    <div className="flowambassador3-container59">
                      <span className="flowambassador3-thq-text-elm32 flow_text">
                        {props.text22121}
                      </span>
                      <span className="flowambassador3-thq-text-elm33 flow_text">
                        {props.text22133221}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt1121}
                    src={props.imageSrc1221}
                    className="flowambassador3-image28"
                  />
                  <img
                    alt={props.imageAlt1261}
                    src={props.imageSrc1761}
                    className="flowambassador3-image29"
                  />
                  <img
                    alt={props.imageAlt12241}
                    src={props.imageSrc17241}
                    className="flowambassador3-image30"
                  />
                  <img
                    alt={props.imageAlt12141}
                    src={props.imageSrc17141}
                    className="flowambassador3-image31"
                  />
                  <img
                    alt={props.imageAlt1741}
                    src={props.imageSrc1841}
                    className="flowambassador3-image32"
                  />
                </div>
              </a>
              <a
                href="mailto:hi@romania.org.ro?subject=Hi @Romania!"
                className="flowambassador3-link5"
              >
                <div className="flowambassador3-thq-field-elm20 ambassador_contact">
                  <div className="flowambassador3-container60">
                    <img
                      alt={props.imageAlt10231}
                      src={props.imageSrc11231}
                      className="flowambassador3-image33"
                    />
                    <div className="flowambassador3-container61">
                      <span className="flowambassador3-thq-text-elm34 flow_text">
                        {props.text2213231}
                      </span>
                      <span className="flowambassador3-thq-text-elm35 flow_text">
                        {props.text2213341}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt122121}
                    src={props.imageSrc172121}
                    className="flowambassador3-image34"
                  />
                  <img
                    alt={props.imageAlt12321}
                    src={props.imageSrc17321}
                    className="flowambassador3-image35"
                  />
                  <img
                    alt={props.imageAlt121121}
                    src={props.imageSrc171121}
                    className="flowambassador3-image36"
                  />
                  <img
                    alt={props.imageAlt17121}
                    src={props.imageSrc18121}
                    className="flowambassador3-image37"
                  />
                </div>
              </a>
              <a href="tel:+40750453880" className="flowambassador3-link6">
                <div className="flowambassador3-thq-field-elm21 ambassador_contact">
                  <div className="flowambassador3-container62">
                    <img
                      alt={props.imageAlt102221}
                      src={props.imageSrc112221}
                      className="flowambassador3-image38"
                    />
                    <div className="flowambassador3-container63">
                      <span className="flowambassador3-thq-text-elm36 flow_text">
                        {props.text22132121}
                      </span>
                      <span className="flowambassador3-thq-text-elm37 flow_text">
                        {props.text22133121}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt1111221}
                    src={props.imageSrc1211221}
                    className="flowambassador3-image39"
                  />
                  <img
                    alt={props.imageAlt122221}
                    src={props.imageSrc172221}
                    className="flowambassador3-image40"
                  />
                  <img
                    alt={props.imageAlt12421}
                    src={props.imageSrc17421}
                    className="flowambassador3-image41"
                  />
                  <img
                    alt={props.imageAlt121221}
                    src={props.imageSrc171221}
                    className="flowambassador3-image42"
                  />
                  <img
                    alt={props.imageAlt17221}
                    src={props.imageSrc18221}
                    className="flowambassador3-image43"
                  />
                </div>
              </a>
            </div>
            <div className="flowambassador3-thq-buttons-elm23">
              <div
                onClick={() => setIsVisible(1)}
                className="flowambassador3-thq-button-elm30 flow_button"
              >
                <span className="flowambassador3-thq-text-elm38">
                  {props.text231}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Flowambassador3.defaultProps = {
  section71: 'Ambassadors Program',
  text212: 'Donate via bank transfer or other preferred methods',
  imageAlt122121: 'image',
  text231: 'Done',
  name31: 'Decide who becomes an Ambassador',
  text23: '07',
  imageAlt1741: 'image',
  text22132121: '+40 750 453 880',
  text24: '07',
  text22133221: 'text us on instagram',
  text221:
    "We are happy to accommodate alternative donation methods according to your preference. Send us an email and we'll get it sorted.",
  imageSrc18221: '/frames/corner_arrow.svg',
  text26: 'Continue ->',
  imagesrc: '/assets/asset%2030-200w.png',
  section4: 'Ambassadors Program',
  text41: 'Name  on the @Romania platform',
  text111:
    'This is a way for you to honor the people around you or even celebrate the memory of someone dear to you, or someone who inspired you, with the title of Ambassador.',
  text39: ' to become an Ambassador or gift the title to others',
  imageSrc9111: '/frames/frame_shape2.svg',
  text25: 'I want to be an Ambassador',
  imageSrc17421: '/frames/corner.svg',
  section21: 'Ambassadors Program',
  imageSrc171121: '/frames/corner.svg',
  imageSrc51: '/formula/roi_blue2.svg',
  imageAlt121121: 'image',
  imageAlt12321: 'image',
  name51: 'Enjoy flexibility in how you contribute',
  imageAlt122221: 'image',
  text14: '07',
  heading: 'Join our initiative as an Ambassador and create positive change',
  text191:
    'When donating as a company or non-profit, please keep in mind that the title of Ambassador along with benefits can only be given to yourself or the people you choose and cannot be attributed to said company or non-profit.',
  text13: '03',
  imageSrc11231: '/assets/ig_blue%20copy%202-200h.png',
  imageSrc71: '/external/roi_blue.svg',
  imageSrc11: '/formula/roi_blue2.svg',
  imageSrc141: '/frames/frame_shape2.svg',
  text171: 'Continue ->',
  text2: 'Continue',
  imageAlt21: 'image',
  text31: 'Signed Certificate of Merit',
  imageSrc18121: '/frames/corner_arrow.svg',
  imageAlt92: 'image',
  name11: 'What you get',
  text110: "I've decided ->",
  imageAlt41: 'image',
  imageAlt71: 'image',
  text12: 'get in touch',
  imageSrc171221: '/frames/corner.svg',
  imageSrc172221: '/frames/corner.svg',
  text20: '07',
  imageSrc21: '/formula/roi_blue2.svg',
  imageSrc17241: '/frames/corner.svg',
  text22121: '@romania',
  section51: 'Ambassadors Program',
  imageAlt1121: 'image',
  imageAlt12241: 'image',
  imageSrc61: '/external/roi_blue.svg',
  imageSrc81: '/frames/frame_shape2.svg',
  imageAlt17121: 'image',
  imageSrc151: '/external/roi_blue.svg',
  caption21111:
    "As a non-profit, we are building value for Romania by lifting its tourism industry. Contributing to our initiative means you help boost our country's economy and you have a positive impact on Romania's tourism promotion.",
  section61: 'Ambassadors Program',
  text9: 'here.',
  imageSrc41: '/formula/roi_blue2.svg',
  imageAlt151: 'image',
  imageAlt31: 'image',
  text71: 'Elite networking opportunities and experiences',
  text22: '07',
  imageSrc1221: '/assets/asset%2030-200w.png',
  name21: 'Create positive change as an Ambassador',
  text5: '07',
  imageAlt12141: 'image',
  imageAlt121221: 'image',
  text10: 'See how your financial contribution creates value for Romania, ',
  imageAlt161: 'image',
  text1212:
    'Donating for yourself means you become an Ambassador and you receive all the benefits associated.',
  imagealt: 'image',
  caption21:
    'We believe that helping build Romania’s Country Brand deserves to be recognized. Join the ranks of pioneers for driving positive change in Romania and be rewarded for your invaluable contribution with equally precious distinction.',
  imageSrc911: '/frames/frame_shape2.svg',
  text12111:
    'Donating for others means they become Ambassadors and they receive all the benefits associated.',
  imageAlt1261: 'image',
  text38: '€5,000 or more',
  text4: '02',
  text101:
    'Choose yourself, friends, family or colleagues or commemorate others by making them Ambassadors',
  text29: 'here.',
  text181: 'Donate as a private person, company or non-profit',
  text16: '07',
  imageSrc1761: '/frames/corner.svg',
  text121:
    'You need to donate €5,000 or more for each person you wish to honor as an Ambassador.',
  imageAlt141: 'image',
  text201: 'Continue ->',
  text2213341: 'send us an email',
  imageSrc1211221: '/assets/asset%2028-200w.png',
  text15: '04',
  imageAlt81: 'image',
  text19: '05',
  text22133121: 'call us',
  imageAlt912: 'image',
  imagealt1: 'image',
  text28: 'here.',
  text51: 'Name on an important monument',
  rootClassName: '',
  imageSrc131: '/external/roi_blue.svg',
  imageAlt51: 'image',
  text21: '07',
  text8:
    'Our mission is to empower Romania via a Country Brand, Media Engine, Tourism and Tourism Promotion platforms and much more. Read all about it ',
  imageSrc1841: '/frames/corner_arrow.svg',
  text11: '01',
  name1: 'Ambassadors are the driving force for growth',
  name61: 'Enjoy flexibility in how you contribute',
  imageAlt1031: 'image',
  text2213231: 'hi@romania.org.ro',
  imageAlt131: 'image',
  imageAlt102221: 'image',
  imageSrc91: '/frames/frame_shape2.svg',
  imageAlt9111: 'image',
  section11: 'Ambassadors Program',
  text27: 'See the complete description of your rewards, ',
  text211: '06',
  imageSrc3: '/formula/roi_blue2.svg',
  section31: 'Ambassadors Program',
  text17:
    "We would be happy to hear from you! So, if you're interested in our Ambassadors Program or would simply like to learn more, send us a message on our socials or send us an email and we'll get started!",
  imageSrc112221: '/assets/ig_blue%20copy%203-200w.png',
  imageAlt12421: 'image',
  text81: 'Continue ->',
  imageAlt1111221: 'image',
  imageAlt61: 'image',
  imageSrc172121: '/frames/corner.svg',
  text37: 'Contribute\xA0',
  imageSrc1131: '/assets/ig_blue%20copy-200w.png',
  imagesrc1: '/assets/asset%2036-200w.png',
  text91: 'Continue ->',
  text61: 'Bespoke medal crafted by the State Mint',
  imageAlt11: 'image',
  name71: 'Get in touch to start your Ambassador journey',
  imageSrc17141: '/frames/corner.svg',
  imageAlt10231: 'image',
  imageSrc17321: '/frames/corner.svg',
  imageSrc161: '/frames/frame_shape2.svg',
  imageAlt17221: 'image',
}

Flowambassador3.propTypes = {
  section71: PropTypes.string,
  text212: PropTypes.string,
  imageAlt122121: PropTypes.string,
  text231: PropTypes.string,
  name31: PropTypes.string,
  text23: PropTypes.string,
  imageAlt1741: PropTypes.string,
  text22132121: PropTypes.string,
  text24: PropTypes.string,
  text22133221: PropTypes.string,
  text221: PropTypes.string,
  imageSrc18221: PropTypes.string,
  text26: PropTypes.string,
  imagesrc: PropTypes.string,
  section4: PropTypes.string,
  text41: PropTypes.string,
  text111: PropTypes.string,
  text39: PropTypes.string,
  imageSrc9111: PropTypes.string,
  text25: PropTypes.string,
  imageSrc17421: PropTypes.string,
  section21: PropTypes.string,
  imageSrc171121: PropTypes.string,
  imageSrc51: PropTypes.string,
  imageAlt121121: PropTypes.string,
  imageAlt12321: PropTypes.string,
  name51: PropTypes.string,
  imageAlt122221: PropTypes.string,
  text14: PropTypes.string,
  heading: PropTypes.string,
  text191: PropTypes.string,
  text13: PropTypes.string,
  imageSrc11231: PropTypes.string,
  imageSrc71: PropTypes.string,
  imageSrc11: PropTypes.string,
  imageSrc141: PropTypes.string,
  text171: PropTypes.string,
  text2: PropTypes.string,
  imageAlt21: PropTypes.string,
  text31: PropTypes.string,
  imageSrc18121: PropTypes.string,
  imageAlt92: PropTypes.string,
  name11: PropTypes.string,
  text110: PropTypes.string,
  imageAlt41: PropTypes.string,
  imageAlt71: PropTypes.string,
  text12: PropTypes.string,
  imageSrc171221: PropTypes.string,
  imageSrc172221: PropTypes.string,
  text20: PropTypes.string,
  imageSrc21: PropTypes.string,
  imageSrc17241: PropTypes.string,
  text22121: PropTypes.string,
  section51: PropTypes.string,
  imageAlt1121: PropTypes.string,
  imageAlt12241: PropTypes.string,
  imageSrc61: PropTypes.string,
  imageSrc81: PropTypes.string,
  imageAlt17121: PropTypes.string,
  imageSrc151: PropTypes.string,
  caption21111: PropTypes.string,
  section61: PropTypes.string,
  text9: PropTypes.string,
  imageSrc41: PropTypes.string,
  imageAlt151: PropTypes.string,
  imageAlt31: PropTypes.string,
  text71: PropTypes.string,
  text22: PropTypes.string,
  imageSrc1221: PropTypes.string,
  name21: PropTypes.string,
  text5: PropTypes.string,
  imageAlt12141: PropTypes.string,
  imageAlt121221: PropTypes.string,
  text10: PropTypes.string,
  imageAlt161: PropTypes.string,
  text1212: PropTypes.string,
  imagealt: PropTypes.string,
  caption21: PropTypes.string,
  imageSrc911: PropTypes.string,
  text12111: PropTypes.string,
  imageAlt1261: PropTypes.string,
  text38: PropTypes.string,
  text4: PropTypes.string,
  text101: PropTypes.string,
  text29: PropTypes.string,
  text181: PropTypes.string,
  text16: PropTypes.string,
  imageSrc1761: PropTypes.string,
  text121: PropTypes.string,
  imageAlt141: PropTypes.string,
  text201: PropTypes.string,
  text2213341: PropTypes.string,
  imageSrc1211221: PropTypes.string,
  text15: PropTypes.string,
  imageAlt81: PropTypes.string,
  text19: PropTypes.string,
  text22133121: PropTypes.string,
  imageAlt912: PropTypes.string,
  imagealt1: PropTypes.string,
  text28: PropTypes.string,
  text51: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc131: PropTypes.string,
  imageAlt51: PropTypes.string,
  text21: PropTypes.string,
  text8: PropTypes.string,
  imageSrc1841: PropTypes.string,
  text11: PropTypes.string,
  name1: PropTypes.string,
  name61: PropTypes.string,
  imageAlt1031: PropTypes.string,
  text2213231: PropTypes.string,
  imageAlt131: PropTypes.string,
  imageAlt102221: PropTypes.string,
  imageSrc91: PropTypes.string,
  imageAlt9111: PropTypes.string,
  section11: PropTypes.string,
  text27: PropTypes.string,
  text211: PropTypes.string,
  imageSrc3: PropTypes.string,
  section31: PropTypes.string,
  text17: PropTypes.string,
  imageSrc112221: PropTypes.string,
  imageAlt12421: PropTypes.string,
  text81: PropTypes.string,
  imageAlt1111221: PropTypes.string,
  imageAlt61: PropTypes.string,
  imageSrc172121: PropTypes.string,
  text37: PropTypes.string,
  imageSrc1131: PropTypes.string,
  imagesrc1: PropTypes.string,
  text91: PropTypes.string,
  text61: PropTypes.string,
  imageAlt11: PropTypes.string,
  name71: PropTypes.string,
  imageSrc17141: PropTypes.string,
  imageAlt10231: PropTypes.string,
  imageSrc17321: PropTypes.string,
  imageSrc161: PropTypes.string,
  imageAlt17221: PropTypes.string,
}

export default Flowambassador3
